import { Link } from "react-router-dom";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import ServiceNav from "../../components/ServiceNav";

function LifeInsurance() {
  return (
    <>
      <Header />
      <main>
        <section class="tp-hero-area p-relative">
          <div class="tp-hero-wrapper-slider">
            <div class="swiper-container">
              <div class="swiper-wrapper">
                <div
                  class="swiper-slide pt-20 pb-150 tp-hero-bg-image"
                  data-bg-color="#20536d"
                >
                  <img
                    class="tp-hero-bg"
                    src="../assets/images/banner-bg.png"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
        <section class="tp-service-details-area pt-120 pb-120">
          <div class="container">
            <div class="row">
              <div class="col-lg-4">
                <div class="tp-service-widget">
                  <div class="tp-service-widget-item mb-40">
                    <ServiceNav activePath="/LifeInsurance" />
                  </div>
                </div>
              </div>
              <div class="col-lg-8">
                <div class="tp-service-details-wrapper">
                  <h3 class="tp-service-details-title">
                    Life Insurance that protects the People You Love
                  </h3>

                  <div class="tp-postbox-list mr-40">
                    <p>
                      Life insurance is more than a policy — it's financial
                      protection for the people who depend on you.
                    </p>
                    <p>
                      At <strong>Kubera Financial Services</strong>, we help
                      families create financial security through customized life
                      insurance solutions designed for every stage of life.
                    </p>
                  </div>

                  <div class="tp-postbox-list-wrapper">
                    <div class="tp-postbox-list mr-40">
                      <h2 class="tp-postbox-list-title-1">We offer:</h2>
                      <h4 class="tp-postbox-list-title">
                        <i class="fa-regular fa-check"></i> Term Life Insurance
                      </h4>
                      <h4 class="tp-postbox-list-title">
                        <i class="fa-regular fa-check"></i> Whole Life Insurance
                      </h4>
                      <h4 class="tp-postbox-list-title">
                        <i class="fa-regular fa-check"></i> Indexed Universal
                        Life (IUL)
                      </h4>
                      <h4 class="tp-postbox-list-title">
                        <i class="fa-regular fa-check"></i> Final Expense
                        Insurance
                      </h4>
                      <h4 class="tp-postbox-list-title">
                        <i class="fa-regular fa-check"></i> Mortgage Protection
                      </h4>
                      <h4 class="tp-postbox-list-title">
                        <i class="fa-regular fa-check"></i> Life Insurance with
                        Living Benefits
                      </h4>
                      <h4 class="tp-postbox-list-title">
                        <i class="fa-regular fa-check"></i> Cash Value
                        Strategies
                      </h4>
                    </div>
                  </div>

                  <div class="tp-service-details-thumb">
                    <img src="../assets/images/s1.jpeg" alt="" />
                  </div>

                  <div class="tp-postbox-list-wrapper">
                    <div class="tp-postbox-list mr-40">
                      <h2 class="tp-postbox-list-title-1">
                        Why Life Insurance Matters
                      </h2>
                    </div>
                  </div>

                  <div class="tp-service-details-box-2 tp-service-details-box-4 d-flex mb-40">
                    <div class="tp-service-details-box-content mr-30">
                      <h3 class="tp-service-details-subtitle-2">
                        Life insurance can help your loved ones:
                      </h3>
                      <h4 class="tp-service-details-subtitle-3">
                        <i class="fa-regular fa-check"></i> Replace lost income
                      </h4>
                      <h4 class="tp-service-details-subtitle-3">
                        <i class="fa-regular fa-check"></i> Pay off debts or
                        mortgage balances
                      </h4>
                      <h4 class="tp-service-details-subtitle-3">
                        <i class="fa-regular fa-check"></i> Cover final expenses
                      </h4>
                      <h4 class="tp-service-details-subtitle-3">
                        <i class="fa-regular fa-check"></i> Protect children's
                        future education
                      </h4>
                      <h4 class="tp-service-details-subtitle-3">
                        <i class="fa-regular fa-check"></i> Maintain financial
                        stability during difficult times
                      </h4>
                    </div>
                  </div>

                  <div class="tp-postbox-list-wrapper">
                    <div class="tp-postbox-list mr-40">
                      <h2 class="tp-postbox-list-title-1">
                        Living Benefits Matter Too
                      </h2>
                      <p>
                        Some modern life insurance policies include living
                        benefits that may allow access to funds during
                        qualifying critical, chronic, or terminal illnesses.
                      </p>
                    </div>
                  </div>

                  <div class="tp-service-details-box-2 tp-service-details-box-4 d-flex mb-40">
                    <div class="tp-service-details-box-content mr-30">
                      <h3 class="tp-service-details-subtitle-2">
                        Personalized Protection
                      </h3>
                      <p>
                        No two families are the same. We take time to understand
                        your goals, budget, and long-term financial needs before
                        recommending solutions.
                      </p>
                      <p>
                        Whether you are starting a family, planning for
                        retirement, or protecting your legacy, we are here to
                        help you make informed decisions with confidence.
                      </p>
                    </div>
                  </div>

                  <div class="tp-service-bg tp-service-details-box-2 tp-service-details-box-4 d-flex mb-40">
                    <div class="tp-service-details-box-content mr-30">
                      <h3 class="tp-service-details-subtitle-2">
                        We offer free consultation
                      </h3>
                      <p>
                        At Kubera Financial Services, we provide our clients
                        with access to top-quality offerings from the nation's
                        top insurance providers, ensuring value and
                        comprehensive coverage.
                      </p>

                      <h6>Please reach us for free consultation!</h6>
                      <Link class="tp-btn-service" to="/ContactUs">
                        Contact Us
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
export default LifeInsurance;
